import { GuidedTourButton } from 'components/common/GuidedTour/GuidedTour.styled';
import { MapTourDialogBox } from './MapTourDialogBox';
import { MapTourWrapper } from './MapTour.styled';
import { useCallback, useContext, useEffect } from 'react';
import { MapTourContext } from 'context/MapTourContext';
import { useMapTour } from 'pages/Map/hooks/useMapTour/useMapTour';
import { ZoneContext } from 'context/ZoneContext';
import TourConfirmationDialog from 'components/common/GuidedTour/TourConfirmationDialog';
import { useBoolean } from 'hooks';
import { MAP_TOUR_CONFIRMATION, MAP_TOUR_RESUME_CONFIRMATION } from 'constants/text/myMap';

export const MapTour = () => {
    const { tour, isMapTour, setTour } = useContext(MapTourContext);
    const { stations, zone } = useContext(ZoneContext);
    const { startTour, updateTour } = useMapTour();
    const { value: isConfirmationVisble, setTrue: showConfirmation, setFalse: hideConfirmation } = useBoolean();

    useEffect(() => {
        if (isMapTour && stations.length) {
            startTour();
        }
    }, [isMapTour, stations, startTour]);

    const updateTourOnZoneChange = () => {
        tour?.currentStep && updateTour(tour.currentStep);
    };

    const handleContinue = useCallback(() => {
        hideConfirmation();
        startTour();
    }, [startTour]);

    const handleTourClick = useCallback(() => {
        if (!isMapTour) {
            showConfirmation();
        }
    }, [isMapTour]);

    useEffect(() => {
        updateTourOnZoneChange();
    }, [zone.name]);

    useEffect(() => {
        return () => setTour(undefined);
    }, []);

    return (
        <MapTourWrapper>
            {isMapTour ? <MapTourDialogBox /> : null}
            {!isMapTour && isConfirmationVisble ? (
                <TourConfirmationDialog
                    onCancel={hideConfirmation}
                    onContinue={handleContinue}
                    tourStatusKey="map-tour-status"
                    confirmationText={MAP_TOUR_CONFIRMATION}
                    resumeText={MAP_TOUR_RESUME_CONFIRMATION}
                ></TourConfirmationDialog>
            ) : null}
            <GuidedTourButton onClick={handleTourClick} data-testid="map-guided-tour-button" />
        </MapTourWrapper>
    );
};
